import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import ButtonRaised from '@kurtosys/ksys-app-components/dist/components/base/ButtonRaised';

export default InjectedStyledComponent(ButtonRaised, 'app', ['buttonRaised']);